import { Component, computed } from "@angular/core";

@Component({
    selector: "packbo-supplier-card-shimmer",
    templateUrl: "./supplier-card-shimmer.template.html",
    styleUrls: ["./supplier-card-shimmer.style.css"]
})
export class SupplierCardShimmerComponent {
    public readonly numberOfShimmerCards = computed(() => Array.from({ length: 8 }, (_, i) => i));
}
